import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import moment from 'moment/moment';
import { shortenedWeekdayDateWithYear } from 'Consts/DateFormats';
import MuiTooltip from '@material-ui/core/Tooltip';

const styles = (theme) => ({
  customTextInput: {
    cursor: 'pointer',
  },
  root: {
    '& .MuiFormLabel-root.Mui-disabled:not(.Mui-error)': {
      color: 'black',
      background: theme.palette.facet.accentBlue20,
    },
    '& .MuiInputBase-root.Mui-disabled:not(.Mui-error)': {
      color: theme.palette.facet.primaryBlue,
      background: theme.palette.facet.accentBlue20,
      '&:hover': {
        color: theme.palette.facet.primaryBlue,
      },
      '& .MuiInputBase-input': {
        color: theme.palette.facet.primaryBlue,
        cursor: 'pointer',
      },
      '& .MuiSvgIcon-root': {
        color: theme.palette.facet.primaryBlue,
      },
    },
  },
  cancelledInput: {
    '& .MuiFormLabel-root.Mui-disabled:not(.Mui-error)': {
      color: 'black',
      background: theme.palette.facet.accentBlue20,
    },
    '& .MuiInputBase-root.Mui-disabled:not(.Mui-error)': {
      color: theme.palette.facet.primaryBlue,
      background: theme.palette.facet.accentBlue20,
      '&:hover': {
        color: theme.palette.facet.primaryBlue,
      },
      '& .MuiInputBase-input': {
        color: theme.palette.facet.primaryBlue,
      },
      '& .MuiSvgIcon-root': {
        color: theme.palette.facet.primaryBlue,
      },
    },
  },
});

const EditMeetingDateField = ({
  className,
  classes,
  value,
  onClick,
  isCancelled,
  ...rest
}) => {
  const formattedDateValue = moment(value).format(shortenedWeekdayDateWithYear).toString();
  if (isCancelled) {
    return (
      <div test="meeting-reschedule-link">
        <TextField
          {...rest}
          classes={{
            root: classes.cancelledInput,
          }}
          value={formattedDateValue}
          disabled
        />
      </div>
    );
  }
  return (
    <MuiTooltip placement="top" arrow title="Click to Reschedule">
      <div test="meeting-reschedule-link">
        <TextField
          {...rest}
          classes={{
            root: classes.root,
            readOnlyInput: classes.readOnlyInput,
          }}
          inputProps={{
            className: classes.customTextInput,
          }}
          value={formattedDateValue}
          onClick={onClick}
          disabled
        />
      </div>
    </MuiTooltip>
  );
};

EditMeetingDateField.defaultProps = {
  className: '',
};

EditMeetingDateField.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EditMeetingDateField);
